import { render, staticRenderFns } from "./GjwSelect.vue?vue&type=template&id=34b5578c&scoped=true"
import script from "./GjwSelect.vue?vue&type=script&lang=js"
export * from "./GjwSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5578c",
  null
  
)

export default component.exports